export const supportsFileLoad = window.File && window.FileReader && window.FileList && window.Blob;

export const stripHtmlString = (html) => {
  const div = document.createElement('DIV');
  div.innerHTML = html;

  return div.textContent || div.innerText;
};

export const inlineEditorHtml = htmlString => htmlString.replace(/<\/p><p/g, '</p>&nbsp;<p');

export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

